import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import SystemUpdateAltOutlinedIcon from "@mui/icons-material/SystemUpdateAltOutlined";

export function KitListHeader({ category, images }) {
  const handleDownloadImages = (images = []) => {
    images.forEach((image, index) => {
      setTimeout(() => {
        const enlace = document.createElement("a");
        enlace.href = image.url;
        enlace.download = `imagen${index + 1}.jpg`;
        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
      }, index * 200);
    });
  };

  return (
    <VuiBox
      sx={({ breakpoints }) => ({
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        [breakpoints.down(500)]: {
          gap: "0.5rem",
        },
      })}
    >
      <VuiBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <VuiTypography
          fontStyle="normal"
          fontSize="24px"
          color="white"
          lineHeight="130%"
          sx={({ breakpoints }) => ({
            fontWeight: "700",
            fontSize: "24px",
            [breakpoints.down(500)]: {
              fontSize: "20px",
            },
          })}
        >
          {category.name}
        </VuiTypography>
        {/* {images.length > 0 && (
          <VuiButton
            onClick={() => handleDownloadImages(images)}
            color="white"
            variant="outlined"
            sx={({ breakpoints }) => ({
              background: "transparent",
              fontSize: "12px",
              height: "35px",
              fontWeight: "700",
              borderSize: "2px",
              borderColor: "white",
              padding: "0px 8px",
              width: "166px",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              [breakpoints.down(500)]: {
                width: "max-content",
                padding: "0px 15px",
              },
            })}
          >
            <SystemUpdateAltOutlinedIcon
              sx={{
                margin: "0 5px",
              }}
            />
            Descargar todo
          </VuiButton>
        )} */}
      </VuiBox>
    </VuiBox>
  );
}